export default "__VITE_ASSET__BsihrzhA__"